import { useEffect, useRef } from "react";
import socket from "services/socket";
import { AppLog } from "services";
import { TvMinimalPlay } from "lucide-react";
import flvjs from "flv.js";
import useDialogUploadPostStore from "store/dialog/useDialogUploadPostContentStore";
import { Service } from "utils/services";

export default function VideoJsLiveView() {
  const { streamingKey, isStreaming, setStreaming, streamingInfo, streamingHostCluster } = useDialogUploadPostStore();

  const videoRef = useRef<HTMLVideoElement>(null);
  const flvPlayerRef = useRef<flvjs.Player | null>(null);

  const initializeFlvPlayer = () => {
    const video = videoRef.current;
    if (!video || !flvjs.isSupported()) return;

    const streamUrl = `${streamingHostCluster.view_host_name}/live/${streamingKey}.flv`;

    const player = flvjs.createPlayer({
      type: "flv",
      url: streamUrl,
    });

    player.attachMediaElement(video);
    player.load();
    player.play();

    video.oncanplay = () => {
      AppLog.log("📽️ Video is ready and can play");
    };

    flvPlayerRef.current = player;
  };

  const destroyFlvPlayer = () => {
    if (flvPlayerRef.current) {
      flvPlayerRef.current.destroy();
      flvPlayerRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.oncanplay = null;
    }
  };

  useEffect(() => {
    console.log("streamingKey : ", streamingKey);
    if (!streamingKey) return;
    socket.emit("ownerStreamingJoin", streamingKey);

    const handleStreamStarted = (data: any) => {
      AppLog.log("[Socket] Stream started");
      initializeFlvPlayer();
      setStreaming(data.streaming_info);
    };

    const handleStreamEnded = () => {
      AppLog.log("[Socket] Stream ended");
      destroyFlvPlayer();
      setStreaming(null);
    };

    socket.on("OnFlipFlopStreamStarted", handleStreamStarted);
    socket.on("OnFlipFlopStreamEnded", handleStreamEnded);

    return () => {
      socket.emit("ownerStreamingLeave", streamingKey);
      socket.off("OnFlipFlopStreamStarted", handleStreamStarted);
      socket.off("OnFlipFlopStreamEnded", handleStreamEnded);
      destroyFlvPlayer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [streamingKey]);

  return (
    <div className="relative aspect-[9/16] h-full rounded-xl flex items-center flex-col justify-center overflow-hidden shrink-0 bg-black space-y-2">
      <video
        ref={videoRef}
        className={`w-full h-auto ${Service.toInteger(streamingInfo?.width) > Service.toInteger(streamingInfo?.height) ? " object-contain " : " object-cover "} `}
        autoPlay
        muted
        playsInline
      />

      {!isStreaming && (
        <div className="absolute inset-0 flex flex-col items-center justify-center z-10 bg-black/50 p-2">
          <TvMinimalPlay className="text-white w-10 h-10" />
          <p className="text-white text-center text-sm mt-2">Connect streaming software to go live</p>
        </div>
      )}
    </div>
  );
}

